<div *ngIf="showMessageFlag" class="alert popup-position-class" 
[ngClass]="statusClass" role="alert">
  <button type="button" style="margin-left: 10px" class="close" data-dismiss="alert" aria-label="Close">
    <span aria-hidden="true">&times;</span></button>
  <strong>{{subject}} </strong>
  <span>{{message}}</span>
</div>